<template>
    <div class="safety">
        <page-header
            class="safety__header"
            :filter-disabled="true"
        />
        <div class="safety__content">
            <div class="safety__title-row">
                <back-button
                    v-if="showBackButton"
                    @click="goBack"
                />
                <h1>
                    Безопасность
                </h1>
            </div>
            <div class="safety__subtitle">
                Устройства, в которых вы осуществляли вход в систему.
                Если обнаружили подозрительную запись, нажмите "Выйти".
                Чтобы обезопасить учетную запись, смените пароль.
            </div>
            <safety-table />
        </div>
    </div>
</template>

<script>
import PageHeader from '@/components/PageHeader.vue';
import SafetyTable from '@/components/safety/Table.vue';
import BackButton from '@/components/BackButton.vue';
import useBackButton from '@/composables/useBackButton';

export default {
    name: 'SafetyController',
    components: {
        BackButton,
        PageHeader,
        SafetyTable,
    },
    setup() {
        const { goBack, showBackButton } = useBackButton();

        return {
            goBack,
            showBackButton,
        };
    },
};
</script>

<style lang="scss">
    .safety {
        display: grid;
        height: 100vh;
        gap: 10px;
        grid:
            "header" 64px
            "content" calc(100% - 74px);
    }

    .safety__header {
        grid-area: header;
    }

    .safety__content {
        grid-area: content;
        text-align: left;
        margin: 10px;
    }

    .safety__title-row {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 8px;

        h1 {
            margin: 0;
            line-height: 32px;
        }
    }

    .safety__subtitle {
        color: #000;
        font-size: 14px;
        margin-bottom: 16px;
        padding: 12px 0px;
        background: #fff;
        line-height: 1.5;
    }
</style>
